import React from "react";
import Carousel from "react-material-ui-carousel";
// import { NavigateBeforeRoundedMaterialIcon, NavigateNextRoundedMaterialIcon } from "../../../Icons/MaterialIcons";
import skeleton from "images/skeletonCatalogue.png";
import "./CarouselElement.scss";
import {
	NavigateBeforeRoundedMaterialIcon,
	NavigateNextRoundedMaterialIcon,
} from "Icons/MaterialIcons";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

const CarouselElement = ({ images }) => {
	return (
		<>
			{images.length > 1 ? (
				<Carousel
					autoPlay={false}
					navButtonsAlwaysVisible={true}
					className="catalogue__carousel"
					NextIcon={<NavigateNextRoundedMaterialIcon />}
					PrevIcon={<NavigateBeforeRoundedMaterialIcon />}
					navButtonsWrapperProps={{ className: "wrapBntCarousel" }}
				>
					{images.map((item) => {
						return (
							<>
								<TransformWrapper>
									<TransformComponent contentStyle={{ display: "grid" }}>
										<img className="carousel__img" src={skeleton} alt="" />
										<img src={item} alt="" className="carousel__img" />
									</TransformComponent>
								</TransformWrapper>
							</>
						);
					})}
				</Carousel>
			) : (
				<TransformWrapper>
					<TransformComponent contentStyle={{ display: "grid" }}>
						<img src={images} className="modal__img" alt="" />
					</TransformComponent>
				</TransformWrapper>
			)}
		</>
	);
};

export default CarouselElement;
